import {
  ADD_GROUP,
  CHANGE_GROUPS,
  END_NEW_CALL_LIST,
  END_BULK_DELETE,
  END_BULK_TAGGING,
  END_DELETE_GROUPS,
  END_EDIT_GROUPS,
  END_EMAIL_GROUP,
  SAVE_ACTIVITY,
  SET_ACTIVITY,
  SET_BULK_TAGS,
  SET_NOTES,
  SET_TASKS,
  START_BULK_DELETE,
  START_BULK_TAGGING,
  START_DELETE_GROUPS,
  START_EDIT_GROUPS,
  START_EMAIL_GROUP,
  START_NEW_CALL_LIST
} from '../actions/companies';

export default function (state = {}, action) {
  switch (action.type) {
  case ADD_GROUP: {
    return {
      ...state,
      groups: [...state.groups, action.group]
    };
  }
  case CHANGE_GROUPS: {
    return {
      ...state,
      groups: action.groups
    };
  }
  case END_BULK_DELETE:
    return {
      ...state,
      startBulkDelete: false
    };
  case END_BULK_TAGGING: {
    return {
      ...state,
      startBulkTagging: false,
      bulkTags: []
    };
  }
  case END_EDIT_GROUPS: {
    return {
      ...state,
      editingGroups: null
    };
  }
  case END_EMAIL_GROUP: {
    return {
      ...state,
      emailGroup: null
    };
  }
  case END_DELETE_GROUPS:
    return {
      ...state,
      deletingGroups: null
    };
  case END_NEW_CALL_LIST:
    return {
      ...state,
      startNewCallList: false
    };
  case SET_ACTIVITY:
    return {
      ...state,
      activeActivity: action.activity
    };
  case SAVE_ACTIVITY:
    return {
      ...state,
      activitySaved: action.saved
    };
  case SET_BULK_TAGS:
    return {
      ...state,
      bulkTags: action.tags
    };
  case SET_NOTES:
    return {
      ...state,
      activityNotes: action.notes
    };
  case SET_TASKS:
    return {
      ...state,
      tasks: action.tasks
    };
  case START_BULK_DELETE:
    return {
      ...state,
      startBulkDelete: true
    };
  case START_BULK_TAGGING:
    return {
      ...state,
      startBulkTagging: true,
      bulkTags: []
    };
  case START_DELETE_GROUPS:
    return {
      ...state,
      deletingGroups: action.groups
    };
  case START_EDIT_GROUPS:
    return {
      ...state,
      editingGroups: action.groups
    };
  case START_EMAIL_GROUP:
    return {
      ...state,
      emailGroup: action.emails
    };
  case START_NEW_CALL_LIST:
    return {
      ...state,
      startNewCallList: true
    };
  }
  return { ...state };
}
